import Vue from "vue";
import VueRouter from "vue-router";
import Dashboard from "../views/Dashboard.vue";
import AccountSettings from "../views/AccountSettings.vue";
import ManageCard from "../views/ManageCard.vue";
import AnalyticDashboard from "../views/AnalyticDashboard.vue";
import CardHolders from "../views/CardHolders.vue";
import OnboardCardholders from "../views/OnboardCardholders.vue";
import Notifications from "../views/Notifications.vue";

import CRMIntegration from "../views/CRMIntegration.vue";
import MultiConnectComingSoon from "../views/MultiConnectComingSoon.vue";
import IndustrySpecificProfile from "../views/IndustrySpecificProfile.vue";
import PappyonPremiere from "../views/PappyonPremiere.vue";
import Support from "../views/Support.vue";
import Subscription from "../views/Subscription.vue";
import Administration from "../views/Administration.vue";
import Register from "../views/Register.vue";
import PortalAccessInvitation from "../views/PortalAccessInvitation.vue";
import EmailHandler from "../views/EmailHandler.vue";
import Login from "../views/Login.vue";
import VerifyEmail from "../views/VerifyEmail.vue";
import Subscribe from "../views/Subscribe.vue";
import Onboard from "../views/Onboard.vue";
import ManageBilling from "../views/ManageBilling.vue";
import ManageSubscription from "../views/ManageSubscription.vue";
import ManagePremiereProfile from "../views/ManagePremiereProfile.vue";
import ManageBusinessProfile from "../views/ManageBusinessProfile.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import Newsfeed from "../views/Newsfeed.vue";
import OnboardMultiConnect from "../views/OnboardMultiConnect.vue";
import ExplainMultiConnect from "../views/ExplainMultiConnect.vue";
import MultiConnect from "../views/MultiConnect.vue";
import YourEvents from "../views/YourEvents.vue";
import ManageEventForPartner from "../views/ManageEventForPartner.vue";
import AddMultiConnect from "../views/MultiConnect/AddMultiConnect";
import EditMultiConnect from "../views/MultiConnect/EditMultiConnect";
import AddEditBadgeAndQRCode from "../views/AddEditBadgeAndQRCode";
import CardDesign from "../views/CardDesign";
import Analytics from "../views/SuperUser/Analytics";
import ConnectionList from "../views/ConnectionList";
import AddEditInvitationDetails from "../views/MultiConnect/AddEditInvitationDetails";
import EventConnectionList from "../views/MultiConnect/EventConnectionList";
import AddEditSubEvent from "../views/MultiConnect/AddEditSubEvent";
import AddEditSession from "../views/MultiConnect/AddEditSession";
import AddEditSubEventSponsorInvitationDetails from "../views/MultiConnect/AddEditSubEventSponsorInvitationDetails";
import YourBusinessNetworkWrapper from "../views/YourBusinessNetworkWrapper";
import EditFormViewRegistrants from "../components/YourBusinessNetwork/EditFormViewRegistrants";
import BusinessNetworkRegistrantForm from "../components/YourBusinessNetwork/BusinessNetworkRegistrantForm";
import FormSuccessPage from "../components/YourBusinessNetwork/FormSuccessPage"

import JoinEvent from "../views/JoinEvent";


import store from "../store";
import SubscriptionUtility from "@/shared/subscription-utility";
import BusinessAccounts from "../views/BusinessAccounts";
import DashboardLayout from "@/layouts/DashboardLayout";
import PlainLayout from "@/layouts/PlainLayout";
import PlainLayoutWhite from "@/layouts/PlainLayoutWhite";
import EmailHandlerLayout from "@/layouts/EmailHandlerLayout";
import OnboardingLayout from "@/layouts/OnboardingLayout";
import AuthenticationLayout from "@/layouts/AuthenticationLayout";
import OnboardCardholdersLayout from "@/layouts/OnboardCardholdersLayout";
import LinkInBioWrapper from "@/views/LinkInBioWrapper";
import PreviewLinkInBio from "@/views/PreviewLinkInBio";
import ManageOptions from "@/views/ManageOptions";
import EditSpeakers from "@/components/MultiConnect/Session/Speakers/EditSpeakers.vue";

import EditSponsor from "../views/MultiConnect/EditSponsors";
import EditAttendee from "@/views/MultiConnect/EditAttendee.vue";
import {getAuth} from "@/shared/firebase_utils";
import ConnectionsAnalyticsDetails
  from "@/components/MultiConnect/Analytics/AnalyticsDialog/ConnectionsAnalyticsDetails.vue";
import MeetingsAnalyticsDetails from "@/components/MultiConnect/Analytics/AnalyticsDialog/MeetingsAnalyticsDetails.vue";
import PartnerAnalyticsDetails from "@/components/MultiConnect/Analytics/AnalyticsDialog/PartnerAnalyticsDetails.vue";
import PostAnalyticsDetails from "@/components/MultiConnect/Analytics/AnalyticsDialog/PostAnalyticsDetails.vue";
import NotesAnalyticsDetails from "@/components/MultiConnect/Analytics/AnalyticsDialog/NotesAnalyticsDetails.vue";
import AttendeesAnalyticsDetails
  from "@/components/MultiConnect/Analytics/AnalyticsDialog/AttendeesAnalyticsDetails.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: Dashboard,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/manageCard",
    name: "ManageCard",
    component: ManageCard,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/analytics",
    name: "AnalyticDashboard",
    component: AnalyticDashboard,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/accountSettings",
    name: "AccountSettings",
    component: AccountSettings,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/cardHolders",
    name: "CardHolders",
    component: CardHolders,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/onboardCardholders",
    name: "OnboardCardholders",
    component: OnboardCardholders,
    meta: { requiresAuth: true, layout: OnboardCardholdersLayout },
  },
  {
    path: "/notifications",
    name: "Notifications",
    component: Notifications,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/onboardMultiConnect",
    name: "OnboardMultiConnect",
    component: OnboardMultiConnect,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/crmIntegration",
    name: "CRMIntegration",
    component: CRMIntegration,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/multiConnectComingSoon",
    name: "MultiConnectComingSoon",
    component: MultiConnectComingSoon,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/industrySpecificProfile",
    name: "IndustrySpecificProfile",
    component: IndustrySpecificProfile,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/pappyonPremiere",
    name: "PappyonPremiere",
    component: PappyonPremiere,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/support",
    name: "Support",
    component: Support,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/subscription",
    name: "Subscription",
    component: Subscription,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/Administration",
    name: "Administration",
    component: Administration,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { isLoginOrRegister: true, layout: AuthenticationLayout },
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: { isLoginOrRegister: true, layout: AuthenticationLayout },
  },
  {
    path: "/portalAccessInvitation/:permissionId",
    name: "PortalAccessInvitation",
    component: PortalAccessInvitation,
    meta: { isLoginOrRegister: true, layout: AuthenticationLayout },
  },
  {
    path: "/forgotPassword",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: { isLoginOrRegister: true, layout: AuthenticationLayout },
  },
  {
    path: "/emailHandler",
    name: "EmailHandler",
    component: EmailHandler,
    meta: { layout: AuthenticationLayout },
  },
  {
    path: "/verifyEmail",
    name: "VerifyEmail",
    component: VerifyEmail,
    meta: { isEmailVerification: true, layout: AuthenticationLayout },
  },
  {
    path: "/subscribe/:tabIndex",
    name: "Subscribe",
    component: Subscribe,
    meta: { layout: OnboardingLayout },
  },
  {
    path: "/onboard/:tabIndex",
    name: "Onboard",
    component: Onboard,
    meta: { requiresAuth: true, layout: OnboardingLayout },
  },
  {
    path: "/manageBilling",
    name: "ManageBilling",
    component: ManageBilling,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/manageSubscription",
    name: "ManageSubscription",
    component: ManageSubscription,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/managePremiereProfile",
    name: "ManagePremiereProfile",
    component: ManagePremiereProfile,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/manageBusinessProfile",
    name: "ManageBusinessProfile",
    component: ManageBusinessProfile,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/newsfeed",
    name: "Newsfeed",
    component: Newsfeed,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/businessAccounts",
    name: "BusinessAccounts",
    component: BusinessAccounts,
    meta: { requiresAuth: true, layout: PlainLayout },
  },
/*  {
    path: "/linkWithPappyon",
    name: "LinkInBio",
    component: LinkInBioWrapper,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },*/
  {
    path: "/yourBusinessNetwork",
    name: "YourBusinessNetwork",
    component: YourBusinessNetworkWrapper,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/editBusinessNetwork/:id",
    name: "EditBusinessNetwork",
    component: EditFormViewRegistrants,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/form/:id",
    name: "BusinessNetworkRegistrantForm",
    component: BusinessNetworkRegistrantForm,
    meta: { requiresAuth: false },
  },
  {
    path: "/formSuccess/:id",
    name: "FormSuccessPage",
    component: FormSuccessPage,
    meta: { requiresAuth: false },
  },

  {
    path: "/temp/:linkInBioId",
    name: "temp",
    component: PreviewLinkInBio,
    meta: { requiresAuth: false },
  },
  {
    path: "/explainMultiConnect",
    name: "ExplainMultiConnect",
    component: ExplainMultiConnect,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/multiConnect",
    name: "MultiConnect",
    component: MultiConnect,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/yourEvents",
    name: "YourEvents",
    component: YourEvents,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/manageEventForPartner/:eventId",
    name: "ManageEventForPartner",
    component: ManageEventForPartner,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/addMultiConnect/:eventId",
    name: "addMultiConnect",
    component: AddMultiConnect,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/editMultiConnect/:eventId",
    name: "editMultiConnect",
    component: EditMultiConnect,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/manageBadgeQRCode/",
    name: "manageBadgeQRCode",
    component: AddEditBadgeAndQRCode,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/manageOptions",
    name: "manageOptions",
    component: ManageOptions,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/cardDesign",
    name: "cardDesign",
    component: CardDesign,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/analytics-dashboard",
    name: "Analytics",
    component: Analytics,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/connections/:businessCardId",
    name: "connectionList",
    component: ConnectionList,
    meta: { requiresAuth: true, layout: DashboardLayout },
  },
  {
    path: "/event/:eventId/attendee/:attendeeId",
    name: "editAttendeeDetails",
    component: EditAttendee,
    meta: { layout: DashboardLayout, requiresAuth: true },
  },
  {
    path: "/event/:eventId/sponsor/:sponsorsUid",
    name: "addEditInvitationDetails",
    component: AddEditInvitationDetails,
    meta: { layout: AuthenticationLayout },
  },
  {
    path: "/event/:eventId/analytics/connections",
    name: "connectionAnalytics",
    component: ConnectionsAnalyticsDetails,
    meta: {layout: DashboardLayout, requiresAuth: true},
  },
  {
    path: "/event/:eventId/analytics/attendees",
    name: "attendeesAnalytics",
    component: AttendeesAnalyticsDetails,
    meta: {layout: DashboardLayout, requiresAuth: true},
  },
  {
    path: "/event/:eventId/analytics/meetings",
    name: "meetingAnalytics",
    component: MeetingsAnalyticsDetails,
    meta: {layout: DashboardLayout, requiresAuth: true},
  },
  {
    path: "/event/:eventId/analytics/notes",
    name: "notesAnalytics",
    component: NotesAnalyticsDetails,
    meta: {layout: DashboardLayout, requiresAuth: true},
  },
  {
    path: "/event/:eventId/analytics/partners",
    name: "partnerAnalytics",
    component: PartnerAnalyticsDetails,
    meta: {layout: DashboardLayout, requiresAuth: true},
  },
  {
    path: "/event/:eventId/analytics/posts",
    name: "postAnalytics",
    component: PostAnalyticsDetails,
    meta: {layout: DashboardLayout, requiresAuth: true},
  },
  {
    path: "/viewConnections/:eventId",
    name: "multiConnectConnectionList",
    component: EventConnectionList,
    meta: { layout: DashboardLayout, requiresAuth: true },
  },
  {
    path: "/event/:eventId/addSubEvent/:subEventId",
    name: "addEditSubEvent",
    component: AddEditSubEvent,
    meta: { layout: DashboardLayout, requiresAuth: true },
  },
  {
    path: "/event/:eventId/editSponsor/:sponsorId",
    name: "editSponsor",
    component: EditSponsor,
    meta: {layout: DashboardLayout, requiresAuth: true},
  },
  {
    path: "/event/:eventId/addSubEvent/:subEventId/addSession/:sessionId",
    name: "addEditSession",
    component: AddEditSession,
    meta: { layout: DashboardLayout, requiresAuth: true },
  },
  {
    path: "/event/:eventId/addSubEvent/:subEventId/addSession/:sessionId/editSpeaker/:speakerId",
    name: "editSpeaker",
    component: EditSpeakers,
    meta: { layout: DashboardLayout, requiresAuth: true },
  },
  {
    path: "/subEvent/:eventId/sponsor/:sponsorsUid",
    name: "addEditInvitationDetails",
    component: AddEditSubEventSponsorInvitationDetails,
    meta: { layout: AuthenticationLayout },
  },
  {
    path: "/joinevent/:eventId",
    name: "joinEvent",
    component: JoinEvent,
    meta: { layout: PlainLayoutWhite, requiresAuth: false },
  },

  // {
  //   path: '/connections/:businessCardId',
  //   name: 'connectionList',
  //   component: ConnectionList,
  //   meta: {requiresAuth: true, layout: DashboardLayout }
  // }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const auth = getAuth();
  const isAuthenticated = auth.currentUser;
  const isLoginOrRegister = to.matched.some(
    (record) => record.meta.isLoginOrRegister
  );
  const isEmailVerifed = isAuthenticated
    ? isAuthenticated.emailVerified
    : false;
  const isEmailVerification = to.matched.some(
    (record) => record.meta.isEmailVerification
  );
  let isSubscribed = true;
  let isMultiConnectOnboarded = false;

  if (isAuthenticated && store.getters.loggedInUsersUid === "") {
    //The vuex store needs to be initialised
    //Initialise the vuex user module
    await store.dispatch(
      "initializeUserProfile",
      auth.currentUser.uid
    );
  }

  if (isAuthenticated && isEmailVerifed) {
    if (to.name == "BusinessAccounts") {
      next();
      return;
    } else if (store.getters.selectedBusinessProfileId === "") {
      next("/businessAccounts");
      return;
    }
  }

  isSubscribed =
    store.getters.businessProfile.subscriptionStatus === "active" ||
    store.getters.businessProfile.subscriptionStatus === "trialing" ||
    store.getters.businessProfile.subscriptionStatus === "past_due"
      ? true
      : false;

  //Start:Added by Dubey
  // isMultiConnectOnboarded = store.getters.businessProfile.isMultiConnectOnboarded;
  isMultiConnectOnboarded = true;

  //End:Added by Dubey

  if (
    (isLoginOrRegister || isEmailVerification) &&
    isAuthenticated &&
    isEmailVerifed
  ) {
    //The user is trying to access the login, registration or email verification page while they are autheticated and their email is verified
    if (isSubscribed) next("/");
    else next("/subscribe/0");
  } else if (
    isAuthenticated &&
    !isEmailVerifed &&
    !isEmailVerification &&
    !(to.name == "EmailHandler")
  ) {
    //The user is logged in but their email is not verified and they are tring to access a page other that the email verifcation page and email handler page
    //Redirect them to the email verification page
    next("/verifyEmail");
  } else if ((requiresAuth || to.name === "Subscribe") && !isAuthenticated) {
    //The user is trying to accesss a page that reuires authetication (including the subscribe page) while not autheticated
    next({
      path: "/login",
      query: to.query,
    });
  } else if (isEmailVerification && !isAuthenticated) {
    next({
      path: "/login",
      query: to.query,
    });
  }
  //Start: Added by Dubey
  else if (
    requiresAuth &&
    isMultiConnectOnboarded &&
    (to.name == "OnboardMultiConnect" || to.name == "ExplainMultiConnect")
  ) {
    next("/multiConnect");
  }
  //End: Added by Dubey
  else if (requiresAuth && !isSubscribed && to.name != "Subscribe") {
    next("/subscribe/0");
  } else if (to.name === "Subscribe" && isSubscribed) {
    next("/");
  } else next();
});

router.beforeResolve((to, from, next) => {
  if (
    to.name == "Dashboard" ||
    to.name == "Subscription" ||
    to.name == "ManageSubscription" ||
    to.name == "ManageBilling"
  )
  if (!store.getters.businessProfile.partnerRepresentativeToken)
    SubscriptionUtility.updateSubscriptionDetails();
  next();
});

export default router;
